export default "__VITE_ASSET__DkCNCeE4__"